import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Routes, RouterModule} from '@angular/router';
import {FormsModule} from '@angular/forms';

import {LoginPage} from './login/login.page';
import {LoginGuard} from "./login/login.guard";
import {AuthGuard} from "../core/guards/auth.guard";
import {AfterLoginPage} from "./login/after-login.page";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import { UnregisteredComponent } from './unregistered/unregistered.component';

export const routes: Routes = [
    {path: 'login', component: LoginPage, canActivate: [LoginGuard]},
    {path: 'unregistered', component: UnregisteredComponent, canActivate: [AuthGuard]},
    {path: 'after-login', component: AfterLoginPage, canActivate: [AuthGuard]}
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule.forChild(routes),
        NgbModule
    ],
    providers: [
    ],
    declarations: [
        LoginPage,
        AfterLoginPage,
        UnregisteredComponent
    ]
})
export class AuthenticationModule {
}


